import { createSlice } from "@reduxjs/toolkit";

// Helper function to load localStorage data
export const loadLocalRecentSearches = () => {
  try {
    const localData = localStorage.getItem('recentSearchesV2');
    if (localData) {
      const parsed = JSON.parse(localData);
      return parsed.recent || [];
    }
  } catch (error) {
    console.error('Failed to parse local recent searches:', error);
  }
  return [];
};

const initialState = {
  recent: [], // Will be loaded via saga
  lastFetch: null,
  loading: false,
  error: null,
  coachmarkDismissed: JSON.parse(localStorage.getItem('recentSearchesCoachmarkDismissed') || 'false')
};

const recentSearchesSlice = createSlice({
  name: "recentSearches",
  initialState,
  reducers: {
    setRecentSearches: (state, action) => {
      const searches = action.payload || [];
      
      // Sort searches by timestamp in descending order (most recent first)
      state.recent = searches.sort((a, b) => {
        const aTime = a.timestamp ? new Date(a.timestamp).getTime() : 0;
        const bTime = b.timestamp ? new Date(b.timestamp).getTime() : 0;
        return bTime - aTime; // Descending order: most recent first
      });
      
      state.lastFetch = Date.now();
      state.loading = false; // Stop loading when data is set
      state.error = null;
    },
    setRecentSearchesLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRecentSearchesError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    addRecentSearch: (state, action) => {
      const newSearch = action.payload;
      if (!newSearch) return;

      // Remove existing search with same searchKey
      state.recent = state.recent.filter(search => search.searchKey !== newSearch.searchKey);
      
      // Add new search at the beginning
      state.recent.unshift(newSearch);
      
      // Keep only last 10 searches
      if (state.recent.length > 10) {
        state.recent = state.recent.slice(0, 10);
      }
      
      state.lastFetch = Date.now();
    },
    clearRecentSearches: (state) => {
      state.recent = [];
      state.lastFetch = null;
      state.error = null;
    },
    dismissCoachmark: (state) => {
      state.coachmarkDismissed = true;
      localStorage.setItem('recentSearchesCoachmarkDismissed', 'true');
    },
    // Action to trigger loading (for saga)
    loadRecentSearchesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    // Action to trigger saving (for saga)
    saveRecentSearchRequest: (state, action) => {
      // Don't set loading for save operations to avoid UI flicker
    }
  },
});

export const { 
  setRecentSearches, 
  setRecentSearchesLoading, 
  setRecentSearchesError,
  addRecentSearch,
  clearRecentSearches,
  dismissCoachmark,
  loadRecentSearchesRequest,
  saveRecentSearchRequest 
} = recentSearchesSlice.actions;

export default recentSearchesSlice.reducer;
